import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IBaseService } from '../../../core/service/ibase-service';
import { AbstractBaseAddUpdateComponent } from '../../../core/component/abstract-base-add-update-component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StateConstant } from '../../../core/constant/state-constant';
import { CountryConstant } from '../../../core/constant/country-constant';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { CommonSelectListService } from '../../../shared/service/common-select-list.service';
import { ModuleUrlsConstant } from '../../../shared/add-refresh/constant/module-urls-constant';
import { ConfirmDialogService } from '../../../shared/confirm-dialog-box/service/confirm-dialog.service';
import { ACLService } from '../../../shared/AclService/acl.service';
import { ResponseCode } from '../../../core/constant/response-code';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { VendorModuleParamConfigModel } from '../../../modules/vendor-registration/modal/vendor-module-param-config-model';
import { VendorDetailModal } from '../../../modules/vendor-registration/modal/vendor-detail-modal';
import { SalesOrderListComponent } from '../../../modules/sales-order/sales-order-list/sales-order-list.component';
import { BranchLocationComponent } from '../../../modules/party/branch-location/branch-location.component';
import { TermsOfPayment } from '../../../modules/party/modal/terms-of-delivery-const';
import { countryModel, VendorModal } from '../../../modules/vendor-registration/modal/vendor-Modal';
import { UserModal } from '../../../modules/user/modal/user-modal';
import { PartyDetailsBranchModel } from '../../../modules/party/modal/party-details-branch-model';
import { VendorService } from '../../../modules/vendor-registration/service/vendor.service';
import { ProductTypeModel } from '../../../modules/product-type/model/product-type.model';
import { PartyTypeModal } from '../../../modules/party-type/modal/party-type-modal';
import { RoleModal } from '../../../modules/role/modal/role-modal';

interface EmployeeRecord {
  name: string;
  title: string;
  qualifications: string;
  experience: number;
  mobile: string;
  email: string;
}

@Component({
  selector: 'app-vendor-add-update',
  templateUrl: './vendor-add-update.component.html',
  styleUrls: ['./vendor-add-update.component.css']
})
export class VendorAddUpdateComponent  extends AbstractBaseAddUpdateComponent<VendorModal>
implements OnInit, AfterContentInit, AfterViewInit {
private readonly MODULE_PARAM_CONFIG_KEY: string = 'party';
public propertyUrls = ModuleUrlsConstant;
moduleParams = new VendorModuleParamConfigModel(this.moduleParamConfigGlob);
public formGroup: FormGroup;
public data: VendorModal;
private ngbRef: NgbModalRef;
private targetContactIndex = -1;
public stateList = StateConstant;
public countryList = CountryConstant;
public contactData: VendorDetailModal;
public isSelectedSameAddress: boolean;
@ViewChild(SalesOrderListComponent) soListComponent: SalesOrderListComponent;
public productTypeList: Array<ProductTypeModel>;
partyTypeList: Array<PartyTypeModal>;
public selectedPartyType: any= [];
public companyTypeList = [
  {label:'Corporation'},{label:'Limited Liablity Compnies'},{label:'Partnership'},{label:'Sole Partnership'},{label:'Others'}
]
companyCatList = [
  {label:'Free Lancers'},{label:'Government Entity'},{label:'Regular'},{label:'SME Vendor'}
]
titleList = [
  {label:'Mr.'},{label:'Mr. & Mrs.'},{label:'Mrs.'},{label:'Ms.'}
]
serviceList: any = [
  {name:'Accident and Civil Responsibility Insurance'},
  {name:'Accidents & Liabilities Insurance'},
  {name:'Accidents Casualties Support Services'},
  {name:'Accounting & Bookkeeping'},
  {name:'Accounting & Finance Training'},
  {name:'Accounting & Office Machinery Rental'},
  {name:'Acids & Alkalines Trading'},
  {name:'Adhesive & Paper Slitting'},
  {name:'Adhesives Trading'},
  {name:'Administrative Consultancy and Studies'},
  {name:'Administrative Management Services'},
  {name:'Administrative Services for Businessmen'},
  {name:'Administrative Training Services'},
  {name:'Advanced First Aid Training Center'},
  {name:'Advertisement'},
  {name:'Advertisement Designing & Producing'},
  {name:'Advertisement Designing and Production'},
  {name:'Advertising'},
  {name:'Advertising Agency'},
  {name:'Advertising Billboards Contracting'},
  {name:'Advertising Consultancy Services'},
  {name:'Advertising Consultancy Services (DMCC)'},
  {name:'Advertising Requisites Trading'},
  {name:'Advertising Researches & Consultancies'},
  {name:'Advertising Signboards Cleaning Services'},
  {name:'Aerial Advertising Services'},
  {name:'Aerial photography services'},
  {name:'Agricultural Equipment & Accessories Trading'},
  {name:'Agricultural Equipment & Machinery Rental'},
  {name:'Agricultural Equipment & Machinery Spare Parts Trading'},
  {name:'Agricultural Extension Services'},
  {name:'Agricultural Projects Management'},
  {name:'Agricultural Research & Consultancy'},
  {name:'Agricultural Tools Trading'},
  {name:'Agricultural Tractors & Machinery Trading'},
  {name:'Air Cargo Services'},
  {name:'Air-Condition Trading'},
  {name:'Air-Conditioning Units Assembling'},
  {name:'Air-Conditioning, Ventilations & Air Filtration Systems Installation & Maintenan'},
  {name:'Air-condition Repairing and maintenance'},
  {name:'Air-conditioning, Cooling, Heating  and Ventilation Engineering Consultancy'},
  {name:'Air-conditioning, Refrigeration & Air Purifying Equipment Repairing & Maintenanc'},
  {name:'Aircondition & Refrigeration Spare Parts Trading'},
  {name:'Aircraft Cabin Simulators Manufacturing'},
  {name:'Aircraft Classification Services'},
  {name:'Aircraft Cleaning Services'},

  {name:'Aircraft Engine & Parts Repair & Overhaul'},
  {name:'Aircraft Spare Parts & Components Trading'},
  {name:'Aircraft Upholstery Services'},
  {name:'Aircrafts & Helicopters Trading'},
  {name:'Airline Inflight Products Trading'},
  {name:'Air-condition Repairing and maintenance'},
  {name:'Air-conditioning, Cooling, Heating  and Ventilation Engineering Consultancy'},
  {name:'Air-conditioning, Refrigeration & Air Purifying Equipment Repairing & Maintenanc'},
  {name:'Aircondition & Refrigeration Spare Parts Trading'},
  {name:'Aircraft Cabin Simulators Manufacturing'},
  {name:'Agricultural Research & Consultancy'},
  {name:'Agricultural Tools Trading'},
  {name:'Agricultural Tractors & Machinery Trading'},
  {name:'Air Cargo Services'},
  {name:'Air-Condition Trading'},
  {name:'Air-Conditioning Units Assembling'},
  {name:'Air-Conditioning, Ventilations & Air Filtration Systems Installation & Maintenan'},
  {name:'Air-condition Repairing and maintenance'},
  {name:'Air-conditioning, Cooling, Heating  and Ventilation Engineering Consultancy'},
  {name:'Air-conditioning, Refrigeration & Air Purifying Equipment Repairing & Maintenanc'},
  {name:'Aircondition & Refrigeration Spare Parts Trading'},
  {name:'Aircraft Cabin Simulators Manufacturing'},
  {name:'Agricultural Research & Consultancy'},
  {name:'Agricultural Tools Trading'},
  {name:'Agricultural Tractors & Machinery Trading'},
  {name:'Air Cargo Services'},
  {name:'Air-Condition Trading'},
  {name:'Air-Conditioning Units Assembling'},
  {name:'Air-Conditioning, Ventilations & Air Filtration Systems Installation & Maintenan'},
  {name:'Air-condition Repairing and maintenance'},
  {name:'Air-conditioning, Cooling, Heating  and Ventilation Engineering Consultancy'},
  {name:'Air-conditioning, Refrigeration & Air Purifying Equipment Repairing & Maintenanc'},
  {name:'Aircondition & Refrigeration Spare Parts Trading'},
  {name:'Aircraft Cabin Simulators Manufacturing'},
  
];
insuranceList = ["Contractor's All Risks", "Professional Indemnity", "Public Liability", "Workmen's Compensation"]
selectedState: {
  id: number;
  name: string;
};
selectedCountry: countryModel;
bankDetailsVisible = true;
filterUrl = this.propertyUrls.filterDataUrl.saleOrderFilterCustomerWise.filterUrl;
getFilterListUrl = '';
systemParam: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);

@ViewChild(BranchLocationComponent) branchChild: BranchLocationComponent;
termsOfPaymentsList = TermsOfPayment;
vendorId;
userName: string;
password: string;
email: string;
mobileNo: number;
cityList: any = [];
records: EmployeeRecord[] = [];
newRecord: EmployeeRecord = {
  name: '',
  title: '',
  qualifications: '',
  experience: 0,
  mobile: '',
  email: ''
};
siteKey = '6LeC2J0mAAAAAOVyV9ZFYxExK6I_V4ktkbLfbNaE'; // Replace with your reCAPTCHA site key
showCaptchaError = false;
captchaResolved = false;
guranteeList: any = [
  {
    name:'Conditionally (only when requested)'
  }
  ,{
    name:'No'
  },{
    name:'Provides only parts warranty'
  },{
    name:'Yes (Company always provide warranty/Guarantee to the works)'
  }];


  supplierForArray : any = [];
  addiInfoOrgaArray: any = [];
  checkBoxValues = [
    {id:'a',value:'Civil Materials'},
    {id:'b',value:'Mechanical Materials'},
    {id:'c',value:'Electrical Materials'},
    {id:'d',value:'Interior Materials'},
    {id:'e',value:'Landscape Materials'},
    {id:'f',value:'Miscellaneous Materials'},
    {id:'g',value:'Scrap Buyers'},
    {id:'h',value:'Others'}
  ]
  additionalImformation = [
    {checked:false,key:'Municipality',value:undefined},
    {checked:false,key:'Roads and Transport Authority',value:undefined},
    {checked:false,key:'Civil Defence',value:undefined},
    {checked:false,key:'Armed Forces',value:undefined},
    {checked:false,key:'Electric and Water Authority',value:undefined},
    {checked:false,key:'Police Headquarter',value:undefined},
    {checked:false,key:'Airport',value:undefined},
    {checked:false,key:'Ports Authority',value:undefined},
    {checked:false,key:'Customs Authority',value:undefined},
    {checked:false,key:'Tourism Authority',value:undefined},
    {checked:false,key:'Others',value:undefined}
  ]
  uploadFormData = new FormData();
constructor(
  public service: VendorService,
  public router: Router,
  public toastrService: ToastrService,
  private activeRoute: ActivatedRoute,
  private formBuilder: FormBuilder,
  private ngbModalService: NgbModal,
  private aclService: ACLService,
  public cdr: ChangeDetectorRef,
  private systemConfigService: SystemConfigService,
  public commonService: CommonSelectListService,
  public confirmationDialogService: ConfirmDialogService,
  private moduleParamConfigGlob: ModuleParamGlobConfigService
) {
  super(toastrService, router);
}

ngOnInit() {
  let id = this.activeRoute.snapshot.paramMap.get('id');
  this.vendorId = id; 
  this.init();
  this.getProductTypes();
}

onCaptchaResolved(response: string) {
  this.captchaResolved = !!response;
  this.showCaptchaError = false;
}


addRecord() {
  this.records.push({ ...this.newRecord });
  this.newRecord = {
    name: '',
    title: '',
    qualifications: '',
    experience: 0,
    mobile: '',
    email: ''
  };
}

getService(): IBaseService<VendorModal> {
  return this.service;
}

async setData(data: VendorModal) {
  this.data = data;
  this.data.ehsPolicyBody = false;
  this.getPartyTypeList();
  if (!this.isUpdateComponent) {
    if (this.data && !this.data.country) {
      this.data.selectedCountry = new countryModel();
      this.data.selectedCountry = this.countryList.find((country) => country.name.toUpperCase() === 'INDIA');
    }
  }
  if (this.isUpdateComponent) {
    if (
      this.data &&
      this.data.partyType &&
      this.data.partyType.key &&
      (this.data.partyType.key === 'Customer' || this.data.partyType.key === 'Both')
    ) {
      this.moduleParams.paramData.transports.isVisible = true;
      this.moduleParams.paramData.salesHead.isVisible = true;
    }
    if (this.data && this.data.state) {
      this.selectedState = this.stateList.find((s) => s.name.toUpperCase() === this.data.state.toUpperCase());
    }
    if (this.data && this.data.country) {
      this.data.selectedCountry = new countryModel();
      this.data.selectedCountry = this.countryList.find(
        (country) => country.name.toUpperCase() === this.data.country.toUpperCase()
      );
    }
    if (!this.isUserAllow) {
      if (this.data && this.data.salesHead) {
        let curr = await this.aclService.getLoggedInUser().toPromise();
        this.data.currentSalesHead = new UserModal();
        this.data.currentSalesHead = curr.data;
        const salesHead = this.data.salesHead.find((sh) => sh.staffid === this.data.currentSalesHead.staffid);
        if (salesHead) {
          this.data.salesHead = new Array<UserModal>();
          this.data.salesHead.push(salesHead);
        }
      }
    }
  }
}

getData(): any {
  // this.formGroup.get('userName').setValue(this.formGroup.get('companyName').value)
  // this.formGroup.get('password').setValue(this.formGroup.get('companyName').value)
  if(this.data.contactDetails && this.data.contactDetails.length > 0){
    this.data.contactDetails.forEach(res => {
      res.userName = this.formGroup.get('companyName').value;
      res.role = new RoleModal();
      res.role.roleid = 69
    })
  // this.data.contactDetails[0].userName = this.formGroup.get('companyName').value;
  // this.data.contactDetails[0].role = new RoleModal();
  // this.data.contactDetails[0].role.roleid = 69
  }
  this.uploadFormData.delete('entityDTOString');
  this.uploadFormData.append('entityDTOString',JSON.stringify(this.formGroup.value))
  return this.uploadFormData;
}

public getModuleHomeUrl(): string {
  this.toastrService.success('Thank you, Your registration request submitted Successfully.', 'Success');
  return '';
}

onCancel() {
  this.router.navigate([''])
}

public getActiveRoute(): any {
  return this.activeRoute;
}

public getNewModal(): VendorModal {
  return new VendorModal();
}

public getFormGroup(): FormGroup {
  return this.formGroup;
}

setValidation() {
  this.formGroup = this.formBuilder.group({
    vendorName: [''],
    telPhoneNo: [''],
    gstNumber: ['', [Validators.minLength(15), Validators.maxLength(15)]],
    panNumber: [''],
    state: [''],
    country: [],
    productType: [''],
    partyType: ['',Validators.required],
    vendorWebsite: [''],
    billAddress: ['', Validators.required],
    billAddress2: ['', Validators.required],
    billAddress3: ['', [Validators.required,Validators.minLength(6), Validators.maxLength(6)]],
    mobile: [''],
    userName: [''],
    password: [''],
    email: [''],
    currency: [],
    poBox: [''],
    companyName: [''],
    licNo: [''],
    issuedAuth: [''],
    issuedAt: [''],
    issuedOn: [''],
    validUpto: [''],
    bankName: [''],
    bankBranch: [''],
    accNumber: [''],
    swiftCode: [''],
    ibanNo: [''],
    resName: [''],
    profQua: [''],
    experience: [''],
    mobileN: [''],
    emailN: [''],
    manStaff: [''],
    labour: [''],
    ehsMan: [''],
    cirtfi: [],
    qaMan:[],
    copfi: [],
    // minimum: [],
    // maximum: [],
    insurance: [],
    inscAtta: [],
    decConfIntre: [],
    // authSig: [],
    // titlDe: [],
    // nohev: [],
    // nolev: [],
    ehsPolicyNo: [false],
    ehsPolicyYes: [true],
    // name: [''],
    // designation: [''],
    // poe: [''],
    // peoTo: [''],

    //companyName1: [],
    companyName2: [],
    typeOfCompany: [],
    physicalAddress: [],
    countryy: [],
    cityy: [],
    telephoneNo: [],
    faxNo: [],
    title: [],
    firstName: [],
    lastName:[],
    poeTo: [],
    tradeLicence: [],
    catCompany: [],
    bankAcc: [],
    legal:[],
    trn: [],
    foreignSupplier: [],
    scopeOfService: [],
    holCompany: [],
    warranty:[],
    ehs: [false],
    ehsIso: [],
    qaqc: [],
    qaIso: [],
    minContractValue: [],
    maxContractValue: [],
    financialInfo: [],
    currentlyEmployedWithUs: [],
    lastTwoProjecBond: [],
    currentlyEmployedName:[],
    currentlyEmployedDesignation: [],
    currentlyEmployedPerFrom: [],
    currentlyEmployedWithTo: [],
    dispute: [],
    disNumInsta: [],
    undertaking: [],
    authSignatory:[],
    authDesignation: [],

    heavyEquipMach: [],
    lightEquipMach:[],

    supplierFor: [],
    addiInfoOrga: [],
    contactDetails:[],
    additionalInformation: [],
    partyDetails: [],
    status: ['pending']
  });
}

removeAddValidationCheck(name: string, required: boolean) {
  this.formGroup.get(`${name}`).clearValidators();
  if (required) this.formGroup.get(`${name}`).setValidators([Validators.required]);
  this.formGroup.get(`${name}`).updateValueAndValidity();
}

formControlValueChanged() {
  const bankNameControl = this.formGroup.get('bankName');
  const ifscControl = this.formGroup.get('ifscCode');
  const accHolderControl = this.formGroup.get('accountHolderName');
  const accNumberControl = this.formGroup.get('accountNumber');

  this.formGroup.get('partyType').valueChanges.subscribe((type) => {
    if ((type ? type.id : 0) === 2) {
      bankNameControl.setValidators([Validators.required]);
      ifscControl.setValidators([Validators.required]);
      accHolderControl.setValidators([Validators.required]);
      accNumberControl.setValidators([this.numberOnlyValidation, Validators.required]);
    } else {
      bankNameControl.clearValidators();
      ifscControl.clearValidators();
      accHolderControl.clearValidators();
      accNumberControl.setValidators([this.numberOnlyValidation]);
    }
    bankNameControl.updateValueAndValidity();
    ifscControl.updateValueAndValidity();
    accHolderControl.updateValueAndValidity();
    accNumberControl.updateValueAndValidity();
  });
}

public getId(): number {
  return this.data.id;
}

get f() {
  return this.formGroup.controls;
}

onAddClick(content) {
  this.targetContactIndex = -1;
  this.contactData = new VendorDetailModal();
  this.ngbRef = this.ngbModalService.open(content, { size: 'lg', backdrop:'static' });
}

onContactSave(eventData: VendorDetailModal) {
  if (!this.data.contactDetails || this.data.contactDetails.length === 0) {
    this.data.contactDetails = new Array<VendorDetailModal>();
  }

  if (this.targetContactIndex >= 0) {
    this.data.contactDetails[this.targetContactIndex] = eventData;
  } else {
    this.data.contactDetails.push(eventData);
  }

  this.targetContactIndex = -1;
  this.ngbRef.close();
}

public onEdit(index: number, content) {
  this.targetContactIndex = index;
  this.contactData = Object.assign({}, this.data.contactDetails[index]);
  this.ngbRef = this.ngbModalService.open(content, { size: 'lg' , backdrop:'static'});
}

public onDelete(i: number) {
  if (confirm('Are you sure?')) {
    this.data.contactDetails.splice(i, 1);
  }
}

onDeleteEmployee(i: number){
  if (confirm('Are you sure?')) {
    this.records.splice(i, 1);
  }
}

public onContactCancel(event) {
  this.ngbRef.close();
}

onStateSelect(event) {
  this.data.state = undefined;
  if (event) this.data.state = event.name;
}

onSubmit() {
  this.data.contactDetails = new Array<VendorDetailModal>();
  this.data.country = this.data.selectedCountry.name;
  this.submitted = true;
  this.setDataToObjects();
  if (this.formGroup.invalid) {
    this.toastrService.warning('Please fill all required fields', 'Error');
    return;
  }
  this.supressMessage = true
  super.onSubmitsupressMessage();
}

setDataToObjects(){
  if (this.selectedPartyType) {
    let tempPartyType = {
      id: this.selectedPartyType.id,
    };
    this.data.partyType = tempPartyType;
  }
  this.supplierForArray = [];
  this.checkBoxValues.forEach((ls) => {
    this.CheckboxControlValue(ls.id,ls.value);
  });
  if(this.supplierForArray && this.supplierForArray.length > 0)
    this.formGroup.get('supplierFor').setValue(this.supplierForArray.toString());
  if(this.records && this.records.length > 0){
    this.records.forEach((ls) => {
      let obj = new VendorDetailModal();
    obj.firstName = ls.name;
    obj.phoneNo = Number(ls.mobile);
    obj.email = ls.email;
    obj.designation = ls.qualifications;
    obj.title = ls.title;
    obj.experience = ls.experience.toString();
    this.data.contactDetails.push(obj);
    })
  }
  if(this.data.contactDetails && this.data.contactDetails.length > 0){
    this.formGroup.get('contactDetails').setValue(this.data.contactDetails);
  }
  this.formGroup.get('additionalInformation').setValue(this.additionalImformation.filter((ls)=> ls.checked));
  if(this.formGroup.get('scopeOfService').value)
  this.formGroup.get('scopeOfService').setValue((this.formGroup.get('scopeOfService').value).toString());
  if(this.formGroup.get('insurance').value)
  this.formGroup.get('insurance').setValue((this.formGroup.get('insurance').value).toString())
  this.setPartyDetailsDTO()
}

setPartyDetailsDTO(){
  let obj : any = {};
  obj.insuranceDocs = [];
  obj.swiftCode = this.formGroup.get('swiftCode').value;
  obj.currency = this.formGroup.get('currency').value;
  obj.status = 'pending';
  obj.ibanNo = this.formGroup.get('ibanNo').value
  obj.companyName = this.formGroup.get('companyName').value
  obj.poBox = this.formGroup.get('poBox').value
  obj.telPhoneNo = this.formGroup.get('telPhoneNo').value
  obj.faxNo = this.formGroup.get('faxNo').value
  obj.tradeLicence = this.formGroup.get('tradeLicence').value
  obj.issuedAt = this.formGroup.get('issuedAt').value
  obj.issuedOn = this.formGroup.get('issuedOn').value
  obj.issuedAuth = this.formGroup.get('issuedAuth').value
  obj.validUpto = this.formGroup.get('validUpto').value
  obj.trn = this.formGroup.get('trn').value
  obj.typeOfCompany = this.formGroup.get('typeOfCompany').value
  obj.labour = this.formGroup.get('labour').value
  obj.catCompany = this.formGroup.get('catCompany').value
  obj.holCompany = this.formGroup.get('holCompany').value
  obj.foreignSupplier = this.formGroup.get('foreignSupplier').value
  obj.supplierFor = this.formGroup.get('supplierFor').value
  obj.scopeOfService = this.formGroup.get('scopeOfService').value
  obj.warranty = this.formGroup.get('warranty').value
  obj.ehs = this.formGroup.get('ehs').value
  obj.ehsIso = this.formGroup.get('ehsIso').value
  obj.qaqc = this.formGroup.get('qaqc').value
  obj.qaIso = this.formGroup.get('qaIso').value
  obj.minContractValue = this.formGroup.get('minContractValue').value
  obj.maxContractValue = this.formGroup.get('maxContractValue').value
  obj.insurance = this.formGroup.get('insurance').value
  obj.financialInfo = this.formGroup.get('financialInfo').value
  obj.decConfIntre = this.formGroup.get('decConfIntre').value
  obj.currentlyEmployedWithUs = this.formGroup.get('currentlyEmployedWithUs').value
  obj.currentlyEmployedName = this.formGroup.get('currentlyEmployedName').value
  obj.currentlyEmployedDesignation = this.formGroup.get('currentlyEmployedDesignation').value
  obj.currentlyEmployedPerFrom = this.formGroup.get('currentlyEmployedPerFrom').value
  obj.currentlyEmployedWithTo = this.formGroup.get('currentlyEmployedWithTo').value
  obj.dispute = this.formGroup.get('dispute').value
  obj.disNumInsta = this.formGroup.get('disNumInsta').value
  obj.lastTwoProjecBond = this.formGroup.get('lastTwoProjecBond').value
  obj.addiInfoOrga = this.formGroup.get('addiInfoOrga').value
  obj.undertaking = this.formGroup.get('undertaking').value
  obj.authSignatory = this.formGroup.get('authSignatory').value
  obj.authDesignation = this.formGroup.get('authDesignation').value
  obj.heavyEquipMach = this.formGroup.get('heavyEquipMach').value
  obj.lightEquipMach = this.formGroup.get('lightEquipMach').value
  obj.additionalInformation = this.formGroup.get('additionalInformation').value
  this.formGroup.get('partyDetails').setValue(obj);  
}

CheckboxControlValue(id, value){
  let a: any = document.getElementById(id)
  if(a.checked){
    this.supplierForArray.push(value)
  }
}

onCountrySelect() {
  this.formGroup.controls.state.enable();
  this.data.country = undefined;
  if (this.data.selectedCountry && this.data.selectedCountry.name.toUpperCase() !== 'INDIA') {
    this.formGroup.controls.state.disable();
  }
  if (this.data.selectedCountry) {
    this.data.country = this.data.selectedCountry.name;
  }
}

onAddressSameClick() {
  this.isSelectedSameAddress = !this.isSelectedSameAddress;
  if (this.data && this.isSelectedSameAddress) {
    this.data.shippingAddress = this.data.billAddress;
    this.data.shippingAddress2 = this.data.billAddress2;
    this.data.shippingAddress3 = this.data.billAddress3;
  } else {
    this.data.shippingAddress = undefined;
    this.data.shippingAddress2 = undefined;
    this.data.shippingAddress3 = undefined;
  }
}

onChangeFileSelection(event,params){
  this.uploadFormData.delete(params);
  this.uploadFormData.append(params,event[0], event[0].name)
}

ngAfterContentInit() {
  this.moduleParams = new VendorModuleParamConfigModel(this.moduleParamConfigGlob);
}

onSalesOrderTabSelect() {
  /*this.activeRoute.params.subscribe((params: Params) => {
    const id = +params['id'];
    this.getFilterListUrl = '';
    this.getFilterListUrl = this.filterUrl + id;
  });*/
}

onAddNewSalesOrder(salesOrderTmp: any) {
  this.ngbRef = this.ngbModalService.open(salesOrderTmp, { windowClass: 'xlModal', backdrop:'static' });
}

onSubmitContinue() {
  this.submitted = true;
  if (this.getFormGroup().invalid) {
    return;
  }
  if ((this.data && !this.data.contactDetails) || this.data.contactDetails.length === 0) {
    this.toastrService.warning('Add at least on Contact Detail!!', 'Error');
    return;
  }

  if (this.branchChild) {
    this.data.branchDetails = new Array<PartyDetailsBranchModel>();
    console.log(this.branchChild.mainData.branchDetails);
    this.data.branchDetails = JSON.parse(JSON.stringify(this.branchChild.mainData.branchDetails));
  }
  if (confirm('Are you sure you want to register this?')) {
    this.onSaveAndContinue(this.getData());
  }
}

onSaveAndContinue(modal: VendorModal) {
  this.getService()
    .save(modal)
    .subscribe(
      (response) => {
        if (response.responseCode != ResponseCode.OK) {
          this.onResponseError(response.responseMessage);
          return;
        }
        const responseParty = response.data;
        this.router.navigate(['/module/vendor/vendor-registration/' + responseParty.id]);
        this.toastrService.success('Thank you, Your registration request submitted Successfully.', 'Success');
      },
      (error) => {
        this.onResponseError(error.message);
      }
    );
}

onRefresh() {}

ngAfterViewInit() {}

onModelCancel() {
  this.ngbRef.close();
}

checkUserRole() {
  this.aclService.getLoggedInUser().subscribe((response) => {
    this.validateResponse(response, () => {
      this.data.currentSalesHead = new UserModal();
      this.data.currentSalesHead = response.data;
      /*** Sales Head */
      if (!this.isUserAllow) {
        this.formGroup.controls.salesHead.disable();
        if (!this.isUpdateComponent) {
          if (!this.data) this.data = new VendorModal();
          if ((this.data && !this.data.salesHead) || this.data.salesHead.length === 0) {
            this.data.salesHead = new Array<UserModal>();
            this.data.salesHead.push(this.data.currentSalesHead);
          }
        }
        if (this.isUpdateComponent) {
          if (this.data && this.data.salesHead) {
            const salesHead = this.data.salesHead.find((sh) => sh.staffid === this.data.currentSalesHead.staffid);
            if (salesHead) {
              this.data.salesHead = new Array<UserModal>();
              this.data.salesHead.push(salesHead);
            }
          }
        }
      }
    });
  });
}
fillPanNumber() {
  if (this.data.gstNumber.length >= 12) {
    this.data.panNumber = this.data.gstNumber.slice(2).substr(0, 10);
  }
}

getProductTypes() {
  if (!this.productTypeList) {
    this.commonService.getProductTypeList().subscribe((response) => {
      this.validateResponse(response, () => {
        this.productTypeList = new Array<ProductTypeModel>();
        this.productTypeList = response.dataList;
      });
    });
  }
}

getPartyTypeList() {
  this.commonService.getPartyTypeList().subscribe((res) => {
    this.partyTypeList = new Array<PartyTypeModal>();
    this.partyTypeList = res.dataList;
  });
}

onBack(){
  this.router.navigate(['']);
}

onChangeEHSRadio(event, module){
  if(module == 'ehs'){
    if(event=='True'){
      this.data.ehsPolicyBody = true;
    }else{
      this.data.ehsPolicyBody = false;
    }
  }
  if(module == 'iso'){
    if(event=='True'){
      this.data.isoManual = true;
    }else{
      this.data.isoManual = false;
    }
  }
  if(module == 'qacManual'){
    if(event=='True'){
      this.data.qacManual = true;
    }else{
      this.data.qacManual = false;
    }
  }
  if(module == 'copyOfCertification'){
    if(event=='True'){
      this.data.copyOfCertification = true;
    }else{
      this.data.copyOfCertification = false;
    }
  }
}

// onBlur(){
//   let a = document.getElementById('a');
//   debugger
//   console.log('form',this.formGroup)
// }
}